import { useGetSettingQuery } from '../../../../Redux/Apis/siteApi';

function Features() {
    const {data :{home: {features : {data,name,caption}}}} = useGetSettingQuery()

    return ( 
        <div className="container-fluid bg-light overflow-hidden my-5 px-lg-0" id='feature'>
            <div className="container feature px-lg-0">
                <div className="row g-0 mx-lg-0">
                    <div className="col-lg-6 feature-text py-5 wow fadeIn" data-wow-delay="0.5s">
                        <div className="p-lg-5 ps-lg-0">
                            <div className="section-title text-start">
                                <h1 className="display-5 mb-4">{name}</h1>
                            </div>
                            <p className="mb-4 pb-2">{caption}</p>
                            <div className="row g-4">
                                
                                {data.lso_features && data.lso_features.map((row,index) =>
                                    <div className="col-6" key={index}>
                                        <div className="d-flex align-items-center">
                                            <div className="d-flex flex-shrink-0 align-items-center justify-content-center bg-white" style={{width: "60px", height: "60px"}}>
                                                <i className={`${row.ico_icon} fa-2x text-primary`}></i>
                                            </div>
                                            <div className="ms-4">
                                                <p className="mb-2">{row.txt_title.split(" ")[0]}</p>
                                                <h5 className="mb-0">{row.txt_title.split(" ").slice(1).join(" ")}</h5>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 pe-lg-0" style={{minHeight: "400px"}}>
                        <div className="position-relative h-100">
                            <img className="position-absolute img-fluid w-100 h-100" src={data.img_image} style={{objectFit: "cover"}} alt=""/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     );
}

export default Features;